<proffeo-ui-page-wrapper>
  @if (!activeCompany()) {
    <div
      class="flex w-full flex-col items-center justify-center gap-4 px-5 pb-5 pt-3 max-sm:px-2 max-md:px-3 max-md:pb-3 lg:pt-6"
    >
      <p class="text-center text-proffeo-muted max-md:text-base">
        {{ 'cooperations.please-select-company-first' | translate }}
      </p>
    </div>
  } @else {
    <div class="flex w-full px-5 pb-5 pt-3 max-sm:px-2 max-md:px-3 max-md:pb-3 lg:pt-6">
      <proffeo-company-cooperations-list
        [companyId]="activeCompany()!.id"
        [incoming]="incoming()"
        [outgoing]="outgoing()"
        class="w-full"
      ></proffeo-company-cooperations-list>
    </div>
  }
</proffeo-ui-page-wrapper>
